import React, { PropsWithChildren } from 'react';
import { Flex } from '../../../shared/components';

export default function TokenPreview({ children }: PropsWithChildren) {
  return (
    <Flex css={{ flexDirection: 'column', alignItems: 'flex-start', gap: '$1', overflow: 'hidden' }}>{children}</Flex>
  );
}
